<template>
    <div class="col-md-12">
        <div>
            <span v-if="assignedShpoUser.username">
                Assigned SHPO User: {{`${assignedShpoUser.firstName} ${assignedShpoUser.lastName}`}} ({{assignedShpoUser.username}})
            </span>
            <!-- (<a :href="`mailto:${assignedShpoUser.username}`">{{assignedShpoUser.username}}</a>) -->
            <button v-if="isVisible" class="btn btn-primary" type="button" name="userAssign" v-on:click="$refs['userAssignModal'].open()">User Assigment</button>
        </div>
        <modal ref="userAssignModal">
            <div slot="header" class="row">
                <h3 class="pull-left align-bottom">User Assignment</h3>
                <button class="btn pull-right" v-on:click="$refs['userAssignModal'].close()">X</button>
            </div>
            <div slot="body">
                <loader v-if="isLoading" />
                <div v-if="!isLoading">
                    <div class="col-md-4">
                        <h5>Current Assigned User:</h5>
                    </div>
                    <div class="col-md-8">
                        <h5>{{assignedUser.username}}</h5>
                    </div>
                    <div class="col-md-12" style="margin-top: 5px;">
                        <v-client-table style="margin: 5px;" :data="assignableUserList" :columns="gridSpec.columns" :options="gridSpec.options">
                            <template slot="reassign" slot-scope="props">
                            <div style="text-align: center;">
                                <a class="fa fa-user" style="font-size: 18px;" v-on:click="reassignUser(props.row)"></a>
                            </div>
                            </template>
                        </v-client-table>
                    </div>
                </div>
            </div>
            <div slot="footer" class="">
                <div class="row">
                    <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['userAssignModal'].close()">Close</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import loggingService from '../services/util/loggingService'
import userAssignmentService from '@/services/userAssignmentService'

import loader from '@/components/Loader.vue'
import modal from '@/components/Modal.vue'

export default {
    components: {
        modal,
        loader
    },
    props: {
        workflowId: { default: null },
        parentId: { default: null }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            isVisible: false,
            assignedUser: {},
            assignedShpoUser: {},
            assignableUserList: [],
            gridSpec: {
                columns: ['reassign', 'name', 'firstName', 'lastName'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 8,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        templateName: 'Template Name',
                        name: 'Username/Email',
                        firstName: 'First Name',
                        lastName: 'Last Name'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'username'
                    }
                }
            },
            selectedNewUserId: null
        }
    },
    computed: {
        userAssignmentDto: function () {
            return {
                parentId: this.parentId,
                workflowId: this.workflowId,
                newUserId: this.selectedNewUserId
            }
        }
    },
    watch: {
        workflowId: function (val) {
            this.log(' - watch.workflowId' + val)
            this.loadData()
        },
        parentId: function (val) {
            this.log(' - watch.parentId' + val)
            this.loadData()
        }
    },
    mounted () {
        this.log('mounted')
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'UserAssignment', message)
        },
        loadAssignedUsers () {
            userAssignmentService.listAssignedUserDtos(this.$http, this.userAssignmentDto).then(response => {
                if (response.data && response.data.length > 0) {
                    this.assignedUser = response.data[0]
                    this.isVisible = true
                }
            })
        },
        reassignUser (user) {
            if (confirm('Are you sure you wish to change the assigned user to: ' + user.name + '?')) {
                this.isLoading = true
                this.selectedNewUserId = user.userId
                userAssignmentService.reassignUser(this.$http, this.userAssignmentDto).then(response => {
                    this.isLoading = false
                    this.loadData()
                })
            }
        },
        loadAssignableUsers () {
            userAssignmentService.listAssignableUsers(this.$http, this.userAssignmentDto).then(response => {
                if (response.data) {
                    this.assignableUserList = response.data
                }
            })
        },
        loadAssignedShpoUsers () {
            userAssignmentService.listAssignedShpoUsers(this.$http, this.userAssignmentDto).then(response => {
                if (response.data && response.data.length > 0) {
                    this.assignedShpoUser = response.data[0]
                }
            })
        },
        loadData () {
            if (this.workflowId && this.parentId) {
                return Promise.all([this.loadAssignableUsers(), this.loadAssignedUsers(), this.loadAssignedShpoUsers()]).then(x => {
                    return x
                })
            }
        }
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// UserAssignment.vue?7b06fb8c